import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const now = new Date();
const timestamp = `${now.getFullYear()}${(now.getMonth() + 1)
  .toString()
  .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now
  .getHours()
  .toString()
  .padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now
  .getSeconds()
  .toString()
  .padStart(2, "0")}`;
function downloadPDFFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: "application/pdf" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.pdf`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

function downloadEXCELFile(blob, fileName) {
  const newBlob = new Blob([blob], {
    type: "application/xlsx",
  });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.xlsx`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

const beneficiaryPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "BENE_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.beneficiaryPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const ftPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FTPENDINGCOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.ftPendingCount, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",

      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.paymentPendingCount, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const beneficiaryGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "GET_BENE_RECORDS",
      ftType: "BENE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.beneficiaryGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const beneAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "BENE_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.beneAuthVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const beneAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "BENE_AUTH_CONFORM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.beneAuthConfirm, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const beneDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "DELETE_INIT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.beneDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",

      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.paymentGetRecords, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.paymentAuthVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.paymentAuthConfirm, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryUploadPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "SALARY_FILE_UPLOAD_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryUploadPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryUploadGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FILEUPLOAD_GETRECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryUploadGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryUploadAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLPAYMENT_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryUploadAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryUploadAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FILEUPLOAD_AUTHCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryUploadAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const ftDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "DELETE_INIT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.ftDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryUploadDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "DELETE_INIT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.salaryUploadDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "DELETE_INIT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.paymentDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepegDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLENQUIRY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.gepegDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerBeneDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "DELETE_INIT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.billerBeneDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerBeneGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.billerBeneficiaryRecords,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerBeneficiaryPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.billerBeneficiaryPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerBeneAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLERBENE_AUTHVERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.billerBeneficiaryAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerBeneAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLERBENE_AUTHCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.billerBeneficiaryAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENTDOWNLOADREC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ftType: "BENE/INSTANT/BULK",
      bulkFlag: "",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.paymentDownload,
      reqParams
    );
    const fileName = `payment_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const ftDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FUNDTRANSFERDOWNLOADREC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ftType: "BENE/INSTANT/BULK",
      bulkFlag: "",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(API_CONFIG.ftDownload, reqParams);
    const fileName = `fundTransfer_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FILEUPLOADDOWNLOADREC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ftType: "BENE/INSTANT/BULK",
      bulkFlag: "",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.fileUploadDownload,
      reqParams
    );
    const fileName = `fileUpload_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billerDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLERBENEFICIARY",
      requestId: "BILLERBENEDOWNLOADREC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ftType: "BENE/INSTANT/BULK",
      bulkFlag: "",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.billerDownload,
      reqParams
    );
    const fileName = `billerBeneficiary_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const beneDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BENEDOWNLOADREC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ftType: "BENE/INSTANT/BULK",
      bulkFlag: "",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.beneDownload,
      reqParams
    );
    const fileName = `beneficiary_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadReceipts = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "DOWNLOAD_RECEIPT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      format: "PDF",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadReceipts,
      reqParams
    );
    const fileName = `fundTransfer_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadPaymentReceipts = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "DOWNLOAD_RECEIPT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      format: "PDF",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadPaymentReceipts,
      reqParams
    );
    const fileName = `bill_payment_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileSingleUploadDownload = async (data, files) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "SALARY_FILE_UPLOAD_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.fileSingleRecordDownload,
      reqParams
    );
    const file = files.replace(".xls", "");
    const fileName = `${file}_${timestamp}`;
    downloadEXCELFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepgPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLENQUIRY",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.gepg_pendingCounts, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepgGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLENQUIRY",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.gepg_getRecords, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepgAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLENQUIRY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.gepg_authVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepgConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLENQUIRY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.gepg_authConfirm, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepegDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLENQUIRY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.gepg_Download,
      reqParams
    );
    const fileName = `gepg_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.debitCardAuthVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.debitCardAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.debitCardDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.debitCardGetRecords, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardAuthorizerPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.debitCardAuthorizerPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardRecDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.debitCardRecDownload,
      reqParams
    );
    const fileName = `debitCard_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "CHEQUEBOOKAUTHVERIFY",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.chequeBookAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "CHEQUEBOOKREQAUTHCONFIRM",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.chequeBookAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DELETECHEQUEBOOKREQUEST",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.chequeBookDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "CHEQUEBOOKRECORDS",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.chequeBookGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookAuthorizerPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "CHEQUEBOOKREQUEST",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.chequeBookAuthorizerPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookRecDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DOWNLOADCHEQUEBOOKREQUEST",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.chequeBookRecDownload,
      reqParams
    );
    const fileName = `chequeBook_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getInitiatorPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "GENERAL",
      requestId: "GET_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getInitiatorPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getConsolidatedCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "COUNTRYCOES",
      requestId: "COUNTRYCOES",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getConsolidatedCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFTConsolidatedCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "GET_AUTHORIZER_PENDING_COUNT",
      requestId: "GET_AUTHORIZER_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getFTConsolidatedCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRepaymentGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "LOANREPAY",
      module: "LOANREPAY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.loanRepaymentGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRepaymentDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "LOANREPAY",
      module: "LOANREPAY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.loanRepaymentDownload,
      reqParams
    );
    const fileName = `loanRepayment${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const LoanRepaymentDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "LOANREPAY",
      requestId: "LOANREPAY_DELETE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.LoanRepaymentDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRepaymentAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "LOANREPAY",
      requestId: "LOANREPAY_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.loanRepaymentAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRepaymentAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "LOANREPAY",
      requestId: "LOANREPAY_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.loanRepaymentAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanstatementDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "LOAN_STATMENT_DONWLOAD",
      module: "LOAN",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      format: "PDF",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.loanstatementDownload,
      reqParams
    );
    const fileName = `loan_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "STOPCHEQUE",
      requestId: "STOPCHEQUE_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.stopChequeAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "STOPCHEQUE",
      requestId: "STOPCHEQUE_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.stopChequeAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "STOPCHEQUE",
      requestId: "STOPCHEQUE_DELETE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.stopChequeDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "STOPCHEQUE",
      module: "STOPCHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.stopChequeGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeRecDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "STOPCHEQUE",
      module: "STOPCHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.stopChequeRecDownload,
      reqParams
    );
    const fileName = `stopCheque_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};
const getSIRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "SI_GET_RECORDS",
      module: "SI",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.siGetRecords, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "SI",
      requestId: "SI_DOWNLOAD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      listType: "ALL",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(API_CONFIG.siDownload, reqParams);
    const fileName = `SI_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "DELETE_SI_INIT",
      module: "SI",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.siDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPaymentConsolidatedCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "GET_AUTHORIZER_PENDING_COUNT",
      requestId: "GET_AUTHORIZER_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getPaymentConsolidatedCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const depositsGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "TERMDEPOSIT_RECORDS",
      module: "TERMDEPOSIT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.depositsGetRecords, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const depositsDelete = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "TERMDEPOSIT",
      requestId: "OPEN_DEPOSIT_DELETE_RECORD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.depositsDelete, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const depositsAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "TERMDEPOSIT",
      requestId: "OPEN_DEPOSIT_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.depositsAuthVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const depositsAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "TERMDEPOSIT",
      requestId: "OPEN_DEPOSIT_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.depositsAuthConfirm, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const depositsDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "TERMDEPOSIT",
      requestId: "GETRECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.depositsDownload,
      reqParams
    );
    const fileName = `deposits_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadGepgPaymentReceipts = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "GEPG",
      requestId: "DOWNLOAD_RECEIPT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      format: "PDF",
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadGepgPaymentReceipts,
      reqParams
    );
    const fileName = `gepg_payment_${timestamp}`;
    downloadPDFFile(response.data, fileName);
    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const PendingAuthService = {
  beneficiaryPendingCount,
  beneficiaryGetRecords,
  ftPendingCount,
  beneAuthVerify,
  beneAuthConfirm,
  paymentPendingCount,
  paymentGetRecords,
  paymentAuthVerify,
  paymentAuthConfirm,
  salaryUploadPendingCount,
  salaryUploadGetRecords,
  salaryUploadAuthVerify,
  salaryUploadAuthConfirm,
  beneDelete,
  paymentDelete,
  salaryUploadDelete,
  ftDelete,
  billerBeneDelete,
  billerBeneficiaryPendingCount,
  billerBeneAuthVerify,
  billerBeneAuthConfirm,
  billerBeneGetRecords,
  beneDownload,
  billerDownload,
  paymentDownload,
  ftDownload,
  fileUploadDownload,
  downloadReceipts,
  downloadPaymentReceipts,
  gepgConfirm,
  gepgAuthVerify,
  gepgGetRecords,
  fileSingleUploadDownload,
  gepgPendingCount,
  gepegDelete,
  gepegDownload,
  debitCardAuthVerify,
  debitCardAuthConfirm,
  debitCardDelete,
  debitCardGetRecords,
  debitCardAuthorizerPendingCount,
  debitCardRecDownload,
  getInitiatorPendingCount,
  chequeBookAuthVerify,
  chequeBookGetRecords,
  chequeBookRecDownload,
  chequeBookAuthorizerPendingCount,
  chequeBookDelete,
  chequeBookAuthConfirm,
  getConsolidatedCount,
  getFTConsolidatedCount,
  loanRepaymentGetRecords,
  loanRepaymentDownload,
  LoanRepaymentDelete,
  loanRepaymentAuthVerify,
  loanRepaymentAuthConfirm,
  loanstatementDownload,
  stopChequeGetRecords,
  stopChequeAuthVerify,
  stopChequeAuthConfirm,
  stopChequeDelete,
  stopChequeRecDownload,
  getSIRecords,
  siDownload,
  siDelete,
  getPaymentConsolidatedCount,
  depositsDownload,
  depositsAuthConfirm,
  depositsAuthVerify,
  depositsDelete,
  depositsGetRecords,
  downloadGepgPaymentReceipts,
};

export default PendingAuthService;
